/* Mat-Haus: count a confirmed Shopify B2B form success, never a button click. */
(function () {
  'use strict';
  if (window.__mhB2BMeasurement) return;
  window.__mhB2BMeasurement = true;
  var key = 'mh_b2b_submission_v1';
  var ttl = 2 * 60 * 60 * 1000;
  var form = document.getElementById('BusinessContactForm');
  var success = document.querySelector('[data-mh-b2b-success]');
  function read() {
    try {
      var value = JSON.parse(sessionStorage.getItem(key) || 'null');
      return value && typeof value.id === 'string' && value.created > Date.now() - ttl ? value : null;
    } catch (_) { return null; }
  }
  function write(value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  }
  if (form && !success) {
    form.addEventListener('submit', function () {
      if (!form.checkValidity() || !window.crypto || !window.crypto.randomUUID) return;
      // No contact details or form contents are stored or sent to analytics.
      write({ id: window.crypto.randomUUID(), created: Date.now(), ga: false, ads: false });
    });
  }
  if (!success || !read()) return;
  var retries = 0;
  var retryPending = false;
  function tag() { window.gtag.apply(window, arguments); }
  function permissions() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return { analytics: false, marketing: false };
    return {
      analytics: privacy.analyticsProcessingAllowed() === true,
      marketing: privacy.marketingAllowed() === true
    };
  }
  function send() {
    var record = read();
    if (!record) return;
    if (record.transport !== 'existing-google-tag-v2') {
      record.ga = false; record.ads = false;
      record.transport = 'existing-google-tag-v2';
    }
    var consent = permissions();
    if ((!consent.analytics || record.ga) && (!consent.marketing || record.ads)) return;
    // Reuse the Google & YouTube app's existing top-level Google tag.
    // Never create another Google tag or change the purchase pixels' consent.
    var ready = typeof window.gtag === 'function' && window.google_tag_manager &&
      (window.google_tag_manager['GT-552QM9F'] || window.google_tag_manager['AW-11030108505']);
    if (!ready) {
      if (!retryPending && retries++ < 60) {
        retryPending = true;
        setTimeout(function () { retryPending = false; send(); }, 500);
      }
      return;
    }
    var cleanUrl = location.origin + location.pathname;
    if (consent.analytics && !record.ga) {
      record.ga = true;
      if (!write(record)) return; // At most once, including reloads; fail closed if storage is unavailable.
      tag('event', 'b2b_quote_submit', { send_to: 'G-70YD3L5260', form_id: 'BusinessContactForm', lead_type: 'b2b_quote', page_location: cleanUrl });
    }
    if (consent.marketing && !record.ads) {
      record.ads = true;
      if (!write(record)) return;
      tag('event', 'conversion', { send_to: 'AW-11030108505/WlWpCNOrtJMdENmyyIsp', transaction_id: record.id, page_location: cleanUrl });
    }
  }
  document.addEventListener('visitorConsentCollected', send);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) send(); });
  }
  send();
})();
